'use client';
import useUtility from "@/app/_hooks/useUtility";
import useBlogs from "../_hooks/useBlogs";
import { BlogItem } from "./BlogItem";
import { BlogSkeleton } from "../_skeleton/BlogSkeleton";

export const Blog = () => {
    const { blogs, loading, pagination, setCurrentPage } = useBlogs();
    const { trans } = useUtility();

    if (loading) {
        return <BlogSkeleton />;
    }

    return (
        <section className="blog-section my-5">
            <div className="container">
                <div className="row justify-content-center g-4">
                    {blogs.map((blog) => (
                        <div key={blog?.id + '-blog'} className="col-lg-4 col-sm-6">
                            <BlogItem blog={blog} />
                        </div>
                    ))}
                </div>

                {pagination && (
                    <div className="pagination">
                        {pagination.prev_page_url && (
                            <button
                                className="btn btn--base"
                                onClick={() =>
                                    setCurrentPage((prev) => prev - 1)
                                }
                            >
                                {trans('Previous')}
                            </button>
                        )}
                        {pagination.next_page_url && (
                            <button
                                className="btn btn--base"
                                onClick={() =>
                                    setCurrentPage((prev) => prev + 1)
                                }
                            >
                                {trans('Next')}
                            </button>
                        )}
                    </div>
                )}
            </div>
        </section>
    );
}